import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppSettingsGoalPage } from './app-settings-goal';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppSettingsGoalPage,
  ],
  imports: [
    IonicPageModule.forChild(AppSettingsGoalPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppSettingsGoalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-settings-goal/app-settings-goal.module.ts